import _extends from "@babel/runtime/helpers/extends";
import { SearchSubmittedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { withFeatureFlags } from '@atlassian/mpac-ui';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getFilters } from "../../../../common/config/filters";
import CommonPropTypes from "../../../../common/constants/proptypes/CommonPropTypes";
import { ANALYTICS_SUBJECT_ID_STANDARD_TEXT_SEARCH, EVENT_CHANNEL, EVENT_SOURCE, OBJECT_TYPE_FILTER } from "../../../constants/analytics/events";
import { SEARCH } from "../../../constants/perspectives";
import AddonDiscoveryPropTypes from "../../../constants/proptypes/AddonDiscoveryPropTypes";
const TextSearchWrapper = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const [query, setQuery] = useState(props.filters.get(getFilters({
    featureFlags: {
      enableJsdToJsm: props.enableJsdToJsm
    }
  }).getIn(['query', 'key'])) || '');
  const formQuery = props.filters.get(getFilters({
    featureFlags: {
      enableJsdToJsm: props.enableJsdToJsm
    }
  }).getIn(['query', 'key'])) || '';
  useEffect(() => {
    const currentQuery = props.filters.get(getFilters({
      featureFlags: {
        enableJsdToJsm: props.enableJsdToJsm
      }
    }).getIn(['query', 'key'])) || '';
    setQuery(currentQuery || '');
  }, [formQuery]);
  const onChangeQuery = newQuery => {
    setQuery(newQuery || '');
    if (props.onChange) {
      props.onChange({
        newQuery,
        newFilters: props.filters.set(getFilters({
          featureFlags: {
            enableJsdToJsm: props.enableJsdToJsm
          }
        }).getIn(['query', 'key']), newQuery)
      });
    }
  };
  const onSubmit = e => {
    e.preventDefault();
    if (!props.onChange) {
      const newFilters = props.filters.set(getFilters({
        featureFlags: {
          enableJsdToJsm: props.enableJsdToJsm
        }
      }).getIn(['query', 'key']), query);
      fireAnalyticsEvent({
        eventType: SearchSubmittedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_STANDARD_TEXT_SEARCH,
        source: EVENT_SOURCE,
        objectType: OBJECT_TYPE_FILTER,
        objectId: 'query',
        attributes: {
          currentPerspective: props.perspective,
          filterValue: query
        }
      }, EVENT_CHANNEL);
      props.stateChangeRequested({
        filters: newFilters,
        perspective: SEARCH
      });
    }
  };
  const SearchComponent = props.searchComponent;
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(SearchComponent, _extends({}, props.extraProps, {
    perspective: props.perspective,
    onChangeQuery: onChangeQuery,
    query: query
  })));
};
TextSearchWrapper.propTypes = {
  fireAnalyticsEvent: PropTypes.func.isRequired,
  extraProps: PropTypes.object,
  filters: CommonPropTypes.filters.isRequired,
  onChange: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  /**
   * searchComponent must contain an input or button element with type "submit"
   * so that the onSubmit of this component's form can be executed
   */
  searchComponent: PropTypes.func.isRequired,
  stateChangeRequested: PropTypes.func.isRequired,
  enableJsdToJsm: PropTypes.bool
};
TextSearchWrapper.defaultProps = {
  extraProps: {}
};
export default withFeatureFlags(TextSearchWrapper);